// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M21 22H3V20H21V22ZM23 18H1V2H23V18ZM16.3174 7.26855L13.4277 9.96484L11.2539 7.93555L10.5713 7.29883L9.88867 7.93555L6.31738 11.2686L5.58691 11.9512L6.95117 13.4131L7.68262 12.7314L10.5713 10.0342L12.7461 12.0645L13.4287 12.7012L14.1113 12.0645L17.6826 8.73145L18.4131 8.04883L17.0488 6.58691L16.3174 7.26855Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-chart-line-board-filled')
export default class ChartLineBoardFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'chart-line-board-filled',
    }
  }
}
